export default "__VITE_ASSET__vCF5KSyk__"